import { MetricsPage } from './MetricsPage'

export default MetricsPage
